import {
  DataFetcher,
  PriorityConfig,
  useGrpcRequest,
} from '@aboutyou/data-fetcher';
import {CategoryNavigationService_GetHeaderBannerLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/navigation/service.grpc.lazy';
import {useOptionalSession} from '@aboutyou/user';
import React, {FC} from 'react';
import {HeaderBanner} from '../../../features/HeaderBanner/HeaderBanner';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useCategoryCacheKeyTransformer, useCategoryIdentifier} from '../utils';

export const CategoryHeaderBanner: FC<PriorityConfig> = ({
  renderingPriority,
}) => {
  return (
    <DataFetcher
      request={useHeaderBannerData()}
      Error={null}
      View={HeaderBanner}
      renderingPriority={renderingPriority}
    />
  );
};

const useHeaderBannerData = () => {
  const categoryIdentifier = useCategoryIdentifier();
  const categoryCacheKeyTransformer = useCategoryCacheKeyTransformer();
  const session = useOptionalSession();

  return useGrpcRequest(
    CategoryNavigationService_GetHeaderBannerLazy,
    {
      category: {
        identifier: categoryIdentifier,
      },
      session,
      reductionsState: useReductionsStateRequestParameter(),
    },
    {
      keepPreviousData: true,
      transformCacheKey: categoryCacheKeyTransformer,
      nonEssential: true,
      // never retry as bas banner is an optional element and rendering it as an aftermath might increase layout shifts on the client
      retry: false,
    },
  );
};
